module.exports = __webpack_public_path__ + "static/media/bloodywood.d66b8de9.webp";